<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import './assets/js/vconsole.min'

// 初始化vConsole
// if(location.host == 'dev.quickbusiness.cn' || location.host == 'localhost:8080'){
if(location.host == 'dev.quickbusiness.cn'){
  window.vConsole = new window.VConsole();
}
window.onload = function() {
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function(event) {
    event.preventDefault()
  })
}
export default {
  name: 'App'
}
</script>

<style>
#app {
  width: 100%;
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/App.vue